import { render } from "./CampaignGroupFilter.vue?vue&type=template&id=2531e9d5"
import script from "./CampaignGroupFilter.vue?vue&type=script&lang=js"
export * from "./CampaignGroupFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__